export default (initialState: any) =>
  (reducerMap: { [x: string]: any }) =>
  (state = initialState, action: { type: string | number }) => {
    const reducer = reducerMap[action.type]
    return reducer ? reducer(state, action) : state
  }
